<div appContainer>
  @if ((projectsLoading$ | async) || (projectLoading$ | async)) {
  <mat-progress-bar mode="query" id="search-loading-bar"></mat-progress-bar>
  }
  <div class="row top-margin">
    <div class="col-md-8">
      <h1 class="header">
        Project Listings
        <button mat-icon-button (click)="refreshListings()" id="refresh-button" data-testid="dashboard-refresh-btn">
          <mat-icon> refresh </mat-icon>
        </button>
      </h1>
    </div>
  </div>

  <section fxLayout="column">
    <div class="search-container" gdColumns="40px 1fr" gdAreas=" icon . clear">
      <mat-icon id="search-icon" gdArea="icon">search</mat-icon>
      <button
        mat-icon-button
        gdArea="clear"
        id="clear-button"
        (click)="clearSearchBar()"
        tabindex="0"
      >
        <mat-icon id="clear-icon">clear</mat-icon>
      </button>
      <input
        matInput
        [formControl]="searchControl"
        type="search"
        id="search-field"
        data-testid="dashboard-search-input"
        gdColumn="1 / -1"
        gdRow="1"
        [ngClass]="{ active: !!searchControl.value }"
        tabindex="0"
      />
    </div>
  </section>

  <div class="projects-card" data-testid="dashboard-project-list" fxLayout="column">
    <button
      fxFlexAlign="end"
      mat-fab
      color="primary"
      type="button"
      (click)="onProjectCreate()"
      matTooltip="Create a new project"
      id="create-project-button"
      data-testid="dashboard-create-project-btn"
    >
      <mat-icon>add</mat-icon>
    </button>
    @if (filteredProjectListings$ | async; as projListings) {
    <mat-tab-group>
      <mat-tab data-testid="dashboard-my-projects-tab">
        <ng-template mat-tab-label
          >My Projects ({{ projListings.myProjects.length }}@if (
          projListings.myProjects.length !== projListings.myProjectCount ) { of
          {{ projListings.myProjectCount }} })</ng-template
        >
        <app-filter-list
          [projects]="projListings.myProjects"
          [headingFilters]="myProjectFilters"
          [total]="projListings.myProjectCount"
          [loading]="projectsLoading$ | async"
          (openProject)="openProject($event)"
        />
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label
          >Pending Projects ({{ projListings.pendingProjects.length }}@if (
          projListings.pendingProjects.length !==
          projListings.pendingProjectsCount ) { of
          {{ projListings.pendingProjectsCount }} })</ng-template
        >
        <app-filter-list
          [projects]="projListings.pendingProjects"
          [headingFilters]="pendingProjectFilters"
          [total]="projListings.pendingProjectsCount"
          [loading]="projectsLoading$ | async"
          (openProject)="openProject($event)"
        />
        <mat-tab>
          <ng-template mat-tab-label
            >Other Projects ({{ projListings.otherProjects.length }}@if (
            projListings.otherProjects.length !== projListings.otherProjectCount
            ) { of {{ projListings.otherProjectCount }} })</ng-template
          >
          <app-filter-list
            [projects]="projListings.otherProjects"
            [total]="projListings.otherProjectCount"
            [loading]="projectsLoading$ | async"
            (openProject)="openProject($event)"
          />
        </mat-tab>
      </mat-tab>
    </mat-tab-group>
    }
  </div>
</div>
